<div mat-dialog-title>
    <h2>Atenção</h2>
</div>
<div mat-dialog-content>
  <p>Nota: Na compra do material do 3º ano do EM, favor optar por uma única área de Itinerário Formativo:</p>
    
  <p><strong>Opção 1 - Ciências Humanas</strong></p>
  <p *ngFor="let item of itens_humanas" class="item_itinerario">{{item}}</p>
  
  <p><strong>Ou</strong></p>

  <p><strong>Opção 2 - Ciências da Natureza</strong></p>
  <p *ngFor="let item of itens_natureza" class="item_itinerario">{{item}}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button cdkFocusInitial color="primary" [mat-dialog-close]="true">Ok</button>
</div>
